import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import CtaLayer from '../Elements/CtaLayer';
import CtaButton from '../Elements/CtaButton';
import Disruptorbar from '../Elements/Disruptorbar';

/**
 * Cta Controller
 *
 * @class
 */
class CtaController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
	  this._registerElements(...CtaLayer, ...CtaButton, ...Disruptorbar);
  }
}

export default new CtaController();
